export default "__VITE_ASSET__R6uKQxAO__"